import { SET_PLATFORM } from '../constant'
//action
export const platform = data =>({type:SET_PLATFORM,data})